module.exports = __webpack_public_path__ + "static/img/media_play.9a0965b3.gif";